import { authRoles } from 'app/auth';
import i18next from 'i18next';

import PiWriterLogEditForm from './editform/PiWriterLogEditForm';
import PiWriterLogTable from './table/PiWriterLogTable';

import en from './i18n/en';
import hu from './i18n/hu';

i18next.addResourceBundle('en', 'piWriterLog', en);
i18next.addResourceBundle('hu', 'piWriterLog', hu);

export default [
	{
		path: '/pi-writer-log/edit/:id/:tabKey?',
		component: PiWriterLogEditForm,
		auth: authRoles.piWriterLog
	},
	{
		path: '/pi-writer-log/:sessionNameParam?',
		component: PiWriterLogTable,
		auth: authRoles.piWriterLog
	}
];